<template>
	<v-layout wrap class="banner" id="home" background>
		<div class="container">
			<v-layout wrap justify-end>
				<v-flex xs12 md6 class="container-desktop">
					<div>
						<img 
							src="/static/images/sections/phone-hand.png" 
							alt="phone"
							class="banner-image-phone">
					</div>
				</v-flex>
				<v-flex xs12 md6 class="align-text container-desktop">
					<h3 class="title-text">TUS CLIENTES <span class="text-orange">CERCA DE TI</span></h3>
					<h2 class="major-text">Sin que salgan de casa</h2>
					<p class="regular-text">Comienza a vender online desde <span class="text-number">{{ numberMoney }}</span></p>
				</v-flex>
				<v-flex xs12 hidden-md-and-up class="banner-image-container">
					<img
						src="/static/images/sections/phone-hand-mobile.png"
						alt="app mi bodega"
						class="banner-image"
					/>
				</v-flex>
				<v-flex>
					<div class="layout justify-end content-actions align-text">
						<div 
						v-for="action in actions" 
						:key="action.id"
						class="actions">
						<btn-action 
							:action="action"
							@open-modal="openModal(action)"/>
						</div>
					</div>
				</v-flex>
				<v-flex xs12 class="container-desktop" v-if="code === 'PE'">
					<div class="container-btn-link">
						<a 
							class="btn-link-detail"
							href="https://mibodega.s3-sa-east-1.amazonaws.com/planes-casa-market-nuevo.pdf"
							target="_blank"
						>Ver Detalle de Planes</a>
					</div>
				</v-flex>
				<v-flex xs12 class="container-desktop">
					<div class="container-btn-link">
						<button 
							class="btn-link-d"
							@click="$emit('open-modal-btn')">SOLICITA TU APP</button>
					</div>
				</v-flex>
			</v-layout>
		</div>
		<v-dialog
			v-model="dialog"
			max-width="90%"
		>
			<div class="container-image-plan">
				<v-btn
					depressed
					flat
					icon
					class="image-plan-btn"
					@click="closeModal"
				>
						<img src="/static/images/sections/close-white.svg" alt="cerrar" height="20">
				</v-btn>
				<img 
					src="/static/images/sections/plan-desktop.png" 
					alt="planes"
					class="image-plan">
			</div>
		</v-dialog>
	</v-layout>
</template>

<script>
import btnAction from '@/components/shared/btn-action';

function openModal({ plan }) {
	this.$emit('open-modal', plan);
}

function openPlans() {
	this.dialog = true;
}

function closeModal() {
	this.dialog = false;
}

function data() {
	return {
		actions: [
			{
				id: 1,
				title: 'QUIERO MI APLICATIVO MÓVIL PERSONALIZADO',
				image: '/static/images/sections/action-1.svg',
				text: 'TU APP PERSONALIZADA',
				link: '#stepbystep',
				outside: false,
				green: true,
				linkPage: `https://casamarket.la/activa-tu-app?plan=true&code=${this.countryCode}&lat=${this.lat}&lon=${this.lon}#formulario`,
				plan: true,
			},
			{
				id: 2,
				title: 'QUIERO RECIBIR PEDIDOS POR CASAMARKET',
				image: '/static/images/sections/action-2.svg',
				text: 'RECIBE PEDIDOS POR CASA MARKET',
				link: process.env.LINK_MARKET_PLACE,
				outside: true,
				green: false,
				linkPage: `https://casamarket.la/activa-tu-app?code=${this.countryCode}&lat=${this.lat}&lon=${this.lon}#formulario`,
				plan: false,
			},
		],
		dialog: false,
	};
}
export default {
	name: 'banner',
	data,
	components: {
		btnAction,
	},
	methods: {
		closeModal,
		openModal,
		openPlans,
	},
	props: {
		numberMoney: String,
		code: String,
		link: String,
		lat: [String, Number],
		lon: [String, Number],
	},
};
</script>
<style lang="scss" scoped>
	.banner {
		background-image: url('/static/images/banners/banner-casa-market-mobile.png');
		background-position: center top;
		background-repeat: no-repeat;
		background-size: cover;
		color: color(info-black);
		justify-content: center;
		height: 560px;
		padding: 80px 17px 0px;
		position: relative;

		// @media (min-width: 360px) {
		// 	height: 289vw;
		// }

		// @media (min-width: 375px) {
		// 	height: 280vw;
		// }

		// @media (min-width: 425px) {
		// 	height: 244vw;
		// }

		// @media (min-width: 768px) {
		// 	height: 140vw;
		// }

		@media (min-width: 1024px) {
			align-items: center;
			background-image: url('/static/images/banners/banner-casa-market.png');
			height: 56vw;
			justify-content: flex-end;
		}

		&-link {
			text-decoration: none;
		}

		&-btn {
			border-radius: 8px;
			font-size: size(medium20);
			font-weight: weight(w900);
			height: 60px !important;
			width: 212px !important;

			@media (min-width: 1024px) {
				width: 271px !important;
			}
		}

		&-image {
			max-width: 100%;
			height: 439px;

			@media (min-width: 360px) {
				height: 450px;
			}
		}
	}

	.align-text {
		text-align: center;

		@media (min-width: 1024px) {
			padding-right: 7.5%;
			text-align: right;
		}
	}

	.title-text {
		font-size: size(large25);
		font-weight: weight(w900);
		line-height: normal;

		@media (min-width: 1024px) {
			font-size: size(large30);
		}

		@media (min-width: 1280px) {
			font-size: size(large40);
		}
	}

	.major-text {
		font-size: size(large30);
		font-weight: weight(w900);
		line-height: normal;
		text-transform: uppercase;

		@media (min-width: 1280px) {
			font-size: size(large40);
		}
	}

	.regular-text {
		color: color(info-black);
		font-size: size(medium20);
		line-height: normal;
		margin: 40px auto 30px;
		max-width: 400px;

		@media (min-width: 1024px) {
			color: color(primary);
			background: rgba(141, 205, 208, 0.45);
			border-radius: 8px;
			font-size: size(medium20);
			padding: 15px 0;
			text-align: center;
			margin: 40px 0px 30px auto;
			max-width: none;
			width: 93%;
		}

		@media (min-width: 1280px) {
			font-size: size(medium20);
		}
	}

	.banner-image-container {
		bottom: 165px;
		left: -9px;
		position: absolute;
		width: 90%;

		@media (max-width: 1024px) {
			bottom: 105px;
			left: 0;
		}

		@media (max-width: 450px) {
			bottom: 93px;
			text-align: center;
		}
	}

	.content-actions {
		@media (max-width: 1024px) {
			bottom: 37px;
			left: 5px;
			position: absolute;
		}
	}

	.text-orange {
		color: color(primary-cs);
	}

	.banner-image-phone {
		bottom: 3px;
		max-height: 40vw;
		position: absolute;
	}

	.container-desktop {
		display: none;

		@media (min-width: 1024px) {
			display: block;
		}
	}

	.text-number {
		color: color(primary);
		font-size: 24px;
		font-weight: 900;
	}

	.container-btn-link {
		margin-left: auto;
		margin-top: 30px;
		text-align: center;
		width: 50%;
	}

	.btn-link-d {
		color: white;
		background: color(primary-cs);
		border-radius: 8px;
		display: inline-block;
		font-size: size(medium20);
		text-decoration: none;
		padding: 18px 50px;
	}

	.btn-link-detail {
		color: color(info-black);
		border: 1px solid color(info-black);
		border-radius: 8px;
		text-decoration: none;
		padding: 8px;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/banner.vue